module.exports = "/_next/static/images/ax-1313bc24de2954f4b53664840b7044d8.svg";